export default __webpack_public_path__ + "static/media/16-BB-(3-2).127683bd.jpg";